export default __webpack_public_path__ + "static/media/@lijoane.411ac719.jpg";